import { render, staticRenderFns } from "./headerSkeleton.vue?vue&type=template&id=efd8347a&xmlns%3Askeleton-item=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./headerSkeleton.vue?vue&type=script&lang=js&"
export * from "./headerSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./headerSkeleton.vue?vue&type=style&index=0&module=%24&lang=less&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$"] = (style0.locals || style0)
        Object.defineProperty(this, "$", {
          configurable: true,
          get: function () {
            return cssModules["$"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./headerSkeleton.vue?vue&type=style&index=0&module=%24&lang=less&"], function () {
          var oldLocals = cssModules["$"]
          if (oldLocals) {
            var newLocals = require("./headerSkeleton.vue?vue&type=style&index=0&module=%24&lang=less&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("efd8347a")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efd8347a')) {
      api.createRecord('efd8347a', component.options)
    } else {
      api.reload('efd8347a', component.options)
    }
    module.hot.accept("./headerSkeleton.vue?vue&type=template&id=efd8347a&xmlns%3Askeleton-item=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&", function () {
      api.rerender('efd8347a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/header/headerSkeleton.vue"
export default component.exports